export default function formString(string, placeholders) {
  var s = string
  for (var propertyName in placeholders) {
    var re = new RegExp('{' + propertyName + '}', 'gm')
    s = s.replace(re, placeholders[propertyName])
  }
  return s
}
